<ion-header
  data-testid="identity-verification-header"
  aria-description="Identity verification"
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <mable-heading
    data-testid="identity-verification-heading"
    heading="h2"
  >
    {{ idVerification.heading }}
  </mable-heading>
  <p
    data-testid="identity-verification-subheading"
    class="ion-margin-horizontal"
    [innerHTML]="idVerification.subheading"
  ></p>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <mable-button
      data-testid="verify-identity-button"
      expand="block"
      category="orange-500"
      (onClick)="handleVerificationAction()"
    >
      {{ idVerification?.ctaActions?.ctaText }}
    </mable-button>
    <ng-container *ngIf="!this.verificationStatus || this.verificationStatus === 'IN_PROGRESS'">
      <mable-button
        data-testid="close-button"
        expand="block"
        class="ion-margin-vertical"
        category="outline"
        (onClick)="closeModal()"
      >
        Close
      </mable-button>
    </ng-container>
  </ion-toolbar>
</ion-footer>
